import i18n from '@src/plugins/i18n'

import { Api } from './AApi'
import {
  ApiHandleParams,
  createApi,
} from './ApiContainer'

const HALF_DAY = 0.5

export const API_DASHBOARD = new Api(
  { only: [] },
  {
    getLog: {
      async request(params) {
        const res = await this.sdk.get('/activity-logs', {
          params,
        })
        return res.data
      },
      type: 'list',
    },
    getDashboard: {
      async request(params) {
        const res = await this.sdk.get(`/dashboard/data`, {
          params,
        })
        return res.data
      },
      type: 'list',
    },
  }
)
export const API_USER = new Api(
  { url: 'users' },
  {
    updatePassword: {
      async request(id, data) {
        const res = await this.sdk.put(`/users/${id}/password`, data)
        return res.data
      },
      type: 'update',
    },
    updateAvatar: {
      async request(id, data) {
        const res = await this.sdk.post(`/users/${id}/avatar`, data, {
          headers: { 'Content-Type': 'multipart/form-data' },
        })
        return res.data
      },
      type: 'update',
      option: {
        handleError: i18n.t('avatar.success'),
        handleSuccess: i18n.t('avatar.error'),
      },
    },
  }
)
const API_ROLE = createApi({
  handle: new ApiHandleParams(),
  api: new Api({
    url: 'roles',
  }),
})
const API_PERMISSION = new Api({
  url: 'permissions',
  only: ['list'],
})
const API_LOG = new Api({
  url: 'logs',
  only: ['list', 'destroy', 'getDetail'],
})
export { API_LOG, API_PERMISSION, API_ROLE }
export * from './ApiContainer'
export * from './modules'
